import { IRectangleCoordinatable, IPoint } from "../../../../../../../base/domain/drawing";
import { IRectangleCoordinatableObjectBean } from "../../../beans/objects";
import { IntegerTranslator } from "../../values";

export class LocationTranslator {
  from(bean: IRectangleCoordinatableObjectBean): IPoint {
    return {
      x: this.integer.from(bean["@x"]),
      y: this.integer.from(bean["@y"]),
    };
  }

  to(object: IRectangleCoordinatable): IPoint<string> {
    return {
      x: this.integer.to(object.location.x),
      y: this.integer.to(object.location.y),
    };
  }

  private readonly integer = new IntegerTranslator();
}
